<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel?.loadingOpts$ | async"> </app-loading>

<lib-reactive-form-group
  #formGroupComponent
  [mergeKey]="'manageLabelSmartFilters'"
  [dispersedKey]="'manageLabelSmartFilters'"
  [bindTo]="viewModel.label$ | async"
  (formSubmitted$)="viewModel.saveSmartLabelChanges()">
</lib-reactive-form-group>

<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="'manage-label-smart-filters'" [stickyOrder]="0">
    <div class="modal-header no-bottom-border">
      <div class="modal-title">Manage Label Smart Filters</div>
    </div>
    <hr class="no-margin" />
  </lib-sticky-header>
  <lib-sticky-body>
    <div class="manage-label-smart-filters-container">
      <div
        libStickyAutoPosition
        class="label-preview-container pt-24px"
        [stickyCollectionKey]="'manage-label-smart-filters'"
        [stickyOrder]="1">
        <app-label-inflator
          [zoom]="1"
          [displayLabelInterface]="
            viewModel.label$
              | async
              | getDisplayLabelInterfaceForManageLabelSmartFilters: viewModel.displayLabelData$
              | async
          ">
        </app-label-inflator>
      </div>

      <app-reactive-form-smart-filter-list
        libStickyAutoPosition
        [stickyCollectionKey]="'manage-label-smart-filters'"
        [stickyOrder]="2"
        [stickChildClassInstead]="'smart-filters-section'"
        #smartFilters
        class="smart-filter-list"
        [dispersedKey]="'manageLabelSmartFilters'"
        [inputName]="'smartFilterIds'"
        [bindingProperty]="'smartFilterIds'">
      </app-reactive-form-smart-filter-list>

      <lib-reactive-form-switch
        class="remove-existing-products-switch"
        [class.disabled]="!(smartFilters.smartFilterIds$ | async)?.length"
        [disabled]="!(smartFilters.smartFilterIds$ | async)?.length"
        [dispersedKey]="'manageLabelSmartFilters'"
        [inputName]="'removeExistingProductsSwitch'"
        [bindingProperty]="'removeExistingOnSync'"
        [labelOnRight]="true"
        [label]="'Remove from existing products'"
        [programmaticallyChangeValue]="!(smartFilters.smartFilterIds$ | async)?.length ? false : undefined"
        [tooltip]="
          smartFilters.smartFilterIds$ | async | getRemoveFromExistingProductsTooltip: Types.SmartDataType.Labels
        ">
      </lib-reactive-form-switch>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
      <lib-button-primary
        [disabled]="formGroupComponent.disableSubmit$ | async"
        (buttonClicked)="formGroupComponent.submitForm()">
        Done
      </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
